/** Shared PDF export helpers for bill template DOM nodes. */

export async function ensureHtml2Pdf() {
  if (typeof window !== 'undefined' && window.__acctooHtml2Pdf) {
    return window.__acctooHtml2Pdf;
  }
  const mod = await import('html2pdf.js');
  const lib = mod?.default || mod;
  if (typeof lib !== 'function') {
    throw new Error('html2pdf.js did not export a function');
  }
  if (typeof window !== 'undefined') {
    window.__acctooHtml2Pdf = lib;
  }
  return lib;
}

export function getBillTemplateRoot(container) {
  if (!container) return null;
  return (
    container.querySelector('#invoice-template') ||
    container.querySelector('#quotation-template') ||
    container.querySelector('#challan-template') ||
    container.querySelector('#modern-sales-template') ||
    container.querySelector('#simple-sales-template') ||
    container.querySelector('#invoice-a5-template') ||
    container.firstElementChild
  );
}

export async function buildPdfBlobFromElement(exportRoot) {
  const html2pdf = await ensureHtml2Pdf();
  const opt = {
    // Template provides its own page padding; jsPDF margins + full A4 width crop sides.
    margin: [0, 0, 0, 0],
    filename: 'layout-document.pdf',
    image: { type: 'jpeg', quality: 0.96 },
    html2canvas: {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      letterRendering: false,
      backgroundColor: '#ffffff',
      scrollX: 0,
      scrollY: 0,
    },
    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
    pagebreak: {
      mode: ['css', 'legacy'],
      // Avoid only row-level nodes; large avoid blocks taller than a page get clipped.
      avoid: ['tr', '.invoice-item-row'],
    },
  };
  return html2pdf().set(opt).from(exportRoot).outputPdf('blob');
}

export function openPdfPreviewWindow(pdfBlob, filename) {
  const pdfUrl = URL.createObjectURL(pdfBlob);
  const previewWindow = window.open('', '_blank', 'width=1200,height=800');
  if (!previewWindow) {
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(pdfUrl);
    return;
  }

  previewWindow.document.write(`
    <html>
      <head><title>${filename}</title></head>
      <body style="margin:0">
        <embed src="${pdfUrl}" type="application/pdf" width="100%" height="100%" style="position:absolute;top:0;left:0;bottom:0;right:0;" />
      </body>
    </html>
  `);
  previewWindow.document.close();
}

export function downloadPdfBlob(pdfBlob, filename) {
  const pdfUrl = URL.createObjectURL(pdfBlob);
  const link = document.createElement('a');
  link.href = pdfUrl;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(pdfUrl);
}
